import { render, staticRenderFns } from "./DeudasCaja.vue?vue&type=template&id=589947f3&"
import script from "./DeudasCaja.vue?vue&type=script&lang=js&"
export * from "./DeudasCaja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports